import Axios from "axios";
import React, { useContext } from "react";
import { configContext } from "../config-provider";
import { Spin } from "../loading";
import { BarChart } from "../bar-chart";
import { LineChart } from "../line-chart";
import { PieChart } from "../pie-chart";
import { latestMonth } from "../../utils";

/**
 * The bar chart under "Latest Month" counts ACK_DATE across the month two
 * months back — see `barChart()` in the server's complaint.service.ts. The pie
 * chart beside it uses the month before that one; the heading names the bar
 * chart's month.
 */
const BAR_CHART_MONTHS_AGO = 2;

interface ComplaintOverviewProps {}

interface State {
  lineChart: unknown[];
  pieChart: unknown[];
  barChart: unknown[];
  loading: boolean;
}

export const ComplaintOverview: React.FC<ComplaintOverviewProps> = (props) => {
  const { dataStartMonth } = useContext(configContext);
  const [state, setState] = React.useState<State>({
    lineChart: [],
    pieChart: [],
    barChart: [],
    loading: false,
  });

  React.useEffect(() => {
    setState({ ...state, loading: true });
    Axios.get(`/complaint/overview`, { params: { from: dataStartMonth } })
      .then((res) => {
        setState({
          ...state,
          lineChart: [{ label: "Complaint", data: res.data[0] }],
          pieChart: res.data[1],
          barChart: res.data[2].map((row: any) => ({
            label: row.id,
            data: row.data,
          })),
        });
      })
      .finally(() => {
        setState((prev) => ({
          ...prev,
          loading: false,
        }));
      });
  // eslint-disable-next-line
  }, []);

  return (
    <div className="overview">
      <span className="title">complaint overview</span>

      <div className="contract">
        {/* <span className="title">This Contract</span> */}
        <Spin spin={state.loading}>
          <LineChart data={state.lineChart} />
        </Spin>
      </div>

      <div>
        <span className="title">
          Latest Month <span className="month">&mdash; {latestMonth(BAR_CHART_MONTHS_AGO)}</span>
        </span>
        <div className="latest">
          <div className="left">
            <Spin spin={state.loading}>
              <PieChart
                data={state.pieChart.map((row: any) => row.value)}
                labels={state.pieChart.map((row: any) => row.id)}
              />
            </Spin>
          </div>

          <div className="right">
            <Spin spin={state.loading}>
              <BarChart data={state.barChart} />
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};
